/**
 * @generated SignedSource<<96731032849463e7c31a6b5030b21421>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SubscriptionStatusEnum = "SUBSCRIBED" | "UNSUBSCRIBED" | "%future added value";
export type ContactMarketingViewMembershipsQuery$variables = {
  contactIdentifier: string;
};
export type ContactMarketingViewMembershipsQuery$data = {
  readonly contactMailingLists: ReadonlyArray<{
    readonly mailingList: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly mailingListIdentifier: string;
    readonly status: SubscriptionStatusEnum;
    readonly subscribedAt: any;
    readonly unsubscribedAt: any | null | undefined;
  }>;
};
export type ContactMarketingViewMembershipsQuery = {
  response: ContactMarketingViewMembershipsQuery$data;
  variables: ContactMarketingViewMembershipsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contactIdentifier"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "contactIdentifier",
        "variableName": "contactIdentifier"
      }
    ],
    "concreteType": "ListMembership",
    "kind": "LinkedField",
    "name": "contactMailingLists",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mailingListIdentifier",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subscribedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "unsubscribedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MailingList",
        "kind": "LinkedField",
        "name": "mailingList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContactMarketingViewMembershipsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContactMarketingViewMembershipsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ac636a089d985e392c39290dede4cef7",
    "id": null,
    "metadata": {},
    "name": "ContactMarketingViewMembershipsQuery",
    "operationKind": "query",
    "text": "query ContactMarketingViewMembershipsQuery(\n  $contactIdentifier: ID!\n) {\n  contactMailingLists(contactIdentifier: $contactIdentifier) {\n    mailingListIdentifier\n    status\n    subscribedAt\n    unsubscribedAt\n    mailingList {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3bb135e4ff17b961cf29918100f96f20";

export default node;
